import { Component, OnInit, ViewChild } from '@angular/core';
import { MenuController } from "@ionic/angular";
import { Events } from '../../helpers/events';

// rxjs
import { Subject, Subscription } from "rxjs";
import { debounceTime, take, takeUntil } from "rxjs/operators";

import { UserService } from '../../services/user.service';
import { EventService } from '../../services/event.service';
import { PlatformService } from '../../services/platform.service';
import { TranslateService, LangChangeEvent } from "@ngx-translate/core";

import { MessagesPage } from "../messages/messages.page";

import { User } from '../../models/user';
import { Event } from '../../models/event';
import { Router } from '@angular/router';
import { RouterExtService } from 'src/app/services/router-ext.service';

@Component({
    selector: 'app-tabs',
    templateUrl: './tabs.page.html',
    styleUrls: ['./tabs.page.scss'],
})
export class TabsPage implements OnInit {

    @ViewChild(MessagesPage) private messagesPage: MessagesPage;

    /**
     * unsubscribe subject
     *
     * @type {Subject<void>}
     */
    private ngUnsubscribe: Subject<void> = new Subject<void>();

    /**
     * subscription for event changes subject
     *
     * @type {Subscription}
     */
    private subscriptionEvent: Subscription;

    /**
     * active user
     *
     * @type User
     */
    public user: User;

    /**
     * active event for user
     *
     * @type Event
     */
    public event: Event;

    /**
     * current language
     *
     * @type string
     */
    public userLang: string;

    constructor(
        private router: Router,
        public routerExtService: RouterExtService,
        public plt: PlatformService,
        public menu: MenuController,
        public appEvents: Events,
        public userService: UserService,
        public eventService: EventService,
        public translate: TranslateService
    ) {
        // user language
        this.userLang = this.translate.currentLang;

        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.userLang = event.lang;
        });
    }

    ngOnInit() {
        this.userService.getCurrentUser().pipe(
            takeUntil(this.ngUnsubscribe),
            debounceTime(0)
        ).subscribe((user) => {
            this.user = user;

            // cancel previous subscription
            if (this.subscriptionEvent) {
                this.subscriptionEvent.unsubscribe();
            }

            this.subscriptionEvent = this.eventService.getCurrentEvent().pipe(
                takeUntil(this.ngUnsubscribe),
                debounceTime(0)
            ).subscribe((event) => {
                this.event = event;
            });
        });


    }
    refreshMessages() {
        setTimeout(()=>{
            this.appEvents.publish('refresh:messages', false);
        }, 0);
    }

    refreshAppointments() {
        // NOTE[jg] - solved with ionWillEnter
        // this.appEvents.publish('refresh:appointments');
    }

    openMenu() {
        this.menu.open();
    }
}
